import { Component, Input, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';

import { ReportingPeriod } from '../reporting-period';

/**
 * Provides 'Did Not Purchase' modal dialog functionality.
 */
@Component({
  selector: 'app-did-not-purchase-modal',
  templateUrl: './did-not-purchase.component.html',
  styleUrls: ['./did-not-purchase.component.scss']
})
export class DidNotPurchaseComponent implements OnInit {

  @Input()
  period: ReportingPeriod;

  modalForm: FormGroup;

  constructor(private formBuilder: FormBuilder,
              private activeModal: NgbActiveModal) {
  }

  ngOnInit() {
    this.modalForm = this.formBuilder.group({
      didNotPurchase: ['', Validators.required]
    });
  }

  onCancel() {
    this.activeModal.dismiss();
  }

  onSubmit() {
    if (this.modalForm.invalid) {
      return;
    }

    this.activeModal.close({
      didNotPurchase: this.modalForm.value,
      startDate: this.period.start
    });
  }

}
